import { Constants } from "../constants/constants";

export const DEFAULT_BRAND_COLOR = "#0d9488";

const isValidHex = (color: string): boolean => /^#([0-9a-f]{6})$/i.test(color);

export const getBrandColor = (): string => {
  const saved = localStorage.getItem(Constants.THEME_COLOR);
  return saved && isValidHex(saved) ? saved : DEFAULT_BRAND_COLOR;
};

export const setBrandColor = (color: string): void => {
  localStorage.setItem(Constants.THEME_COLOR, color);
};

const mixHex = (from: string, to: string, ratio: number): string => {
  const parse = (hex: string) => {
    const value = hex.replace("#", "");
    const full =
      value.length === 3
        ? value
            .split("")
            .map((x) => x + x)
            .join("")
        : value;
    const num = parseInt(full, 16);
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
  };

  const a = parse(from);
  const b = parse(to);
  const r = Math.round(a.r + (b.r - a.r) * ratio);
  const g = Math.round(a.g + (b.g - a.g) * ratio);
  const bl = Math.round(a.b + (b.b - a.b) * ratio);

  return `#${((1 << 24) | (r << 16) | (g << 8) | bl).toString(16).slice(1)}`;
};

export const applyBrandColor = (
  element: HTMLElement,
  color?: string,
): void => {
  const resolved = color && isValidHex(color) ? color : getBrandColor();
  const style = element.style;
  style.setProperty("--brand-color", resolved);
  style.setProperty("--brand-dark", mixHex(resolved, "#000000", 0.25));
  style.setProperty("--brand-deep", mixHex(resolved, "#000000", 0.4));
  style.setProperty("--brand-light", mixHex(resolved, "#ffffff", 0.2));
  style.setProperty("--brand-soft", mixHex(resolved, "#ffffff", 0.85));
  style.setProperty("--brand-faint", mixHex(resolved, "#ffffff", 0.93));
};
